import { render, staticRenderFns } from "./404-Page.vue?vue&type=template&id=15ca3267"
var script = {}
import style0 from "./404-Page.vue?vue&type=style&index=0&id=15ca3267&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports